import { render } from "./administrator_cluster_page.vue?vue&type=template&id=0c6815a4&scoped=true"
import script from "./administrator_cluster_page.vue?vue&type=script&lang=js"
export * from "./administrator_cluster_page.vue?vue&type=script&lang=js"

import "./administrator_cluster_page.vue?vue&type=style&index=0&id=0c6815a4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6815a4"]])

export default __exports__